<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaServicos"
      :camposTabela="retornaCamposTabela()"
      :camposMascaraValor="['preco']"
      ordenarPor="codigo"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @clicouItemTabela="clicouItemTabela"
      @limpar="limpar"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroServicos="cadastroServicos"
    />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import ServicosService from '../../services/servicos.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroServicos',
      icon: 'person_add',
      tooltip: 'Cadastrar serviços',
    },
  ],
}

export default {
  name: 'Servicos',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaServicos: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  created() {
    this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const servicos = await ServicosService.retornaTodos(pagina)
        this.listaServicos = servicos.lista
        this.totalDePaginas = servicos.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const servicos = await ServicosService.retornaTodosPorFiltro(filtro, pagina)
        this.listaServicos = servicos.lista
        this.totalDePaginas = servicos.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-servicos-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaServicos = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        codigo: {
          label: 'Código',
        },
        descricao: {
          label: 'Descrição',
        },
        preco: {
          label: 'Preço',
        },
      }
    },
    cadastroServicos() {
      this.$router.push({ name: 'rota-servicos-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
